<div class="tab-gifts">
  <div class="grid">
    <div class="grid__m-4">
      <div class="label-reservations">
        <span>Izaberite datum</span>
      </div>
      <gr-date-picker [minDate]="minDate" [defaultDate]="urlParams.date ? urlParams.date : undefined" (dateSelected)="onSelectedDate($event)"></gr-date-picker>
    </div>
    <div class="grid__m-6"></div>
    <div class="grid__m-2">
      <button (click)="exportOrdersExcel()" class="zc-btn zc-btn--primary">
        <span>Štampaj Excel</span>
      </button>
    </div>
  </div>
  <div class="grid">
    <div class="grid__m-12">
      <div class="zc-table purchased-gift">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Datum</span>
            </div>
            <div class="zc-header-column">
              <span>Barcode</span>
            </div>
            <div class="zc-header-column">
              <span>Ime i prezime</span>
            </div>
            <div class="zc-header-column">
              <span>Adresa dostave</span>
            </div>
            <div class="zc-header-column">
              <span>Kontakt telefon</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div *ngFor="let order of orders" class="zc-content-row">
            <div class="zc-content-column">
              <span>{{ order.reservation_date | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ order.barcode }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ order.first_name + ' ' + order.last_name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{order.address}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ order.user_phone }}</span>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__m-12">
            <gr-pagination
              *ngIf="orders.length"
              [currentPage]="ordersPagination?.currentPage"
              [pagId]="'js-orders-table-pagination'"
              [perPage]="ordersPagination?.perPage"
              [totalItems]="ordersPagination?.totalItems"
              (pageChanged)="onPageChanged($event)">
            </gr-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
